"use client";

import React, { useEffect } from "react";
import Image from "next/image";
import { Text } from "@/components/ui/text";
import posthog from "posthog-js";
import { useSession } from "next-auth/react";

interface ErrorProps {
  error: Error;
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  const { data: user, status: authStatus } = useSession();

  useEffect(() => {
    if (error) {
      if (authStatus !== "authenticated" || !user.user.id) return;
      posthog.capture("Client_error", {
        id: user.user?.id || "",
        firstName: user.user?.firstName || "",
        lastName: user.user?.lastName || "",
        email: user.user?.email || "",
        phoneNumber: user.user?.phoneNumber || "",
        sessionUrl: posthog.get_session_replay_url(),
        sessionId: posthog.get_session_id(),
        error: error.message,
        errorStack: error.stack
      });
    }
  }, [error, user]);

  return (
    <div className="flex w-full h-screen flex-col justify-center items-center ">
      <Image
        alt="keyLogo"
        width={130}
        height={72}
        src={"/static/images/key-black-logo.png"}
        className="rounded-small  "
      />
      <h1 className="text-[60px] text-gray-800  font-black">Oops..</h1>
      <div className="flex flex-col items-center h-fit">
        <p className="text-gray-600 text-[16px] whitespace-nowrap ">
          {" "}
          Looks like something went sideways.
        </p>
        <p className="text-gray-600 text-[16px] whitespace-nowrap text-center">
          We're working on getting things back to normal.<br></br> Please try again in a moment.
        </p>
      </div>
    </div>
  );
}
